import { t as translate } from "../preferences";
import { CircleUserRound, Headphones, ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

export function RestrictedScreen({ zeroCapability }: { zeroCapability: boolean }) {
  return (
    <section className="m-mx-auto m-w-full m-max-w-sm m-py-7 m-text-center">
      <span className="m-mx-auto m-flex m-size-16 m-items-center m-justify-center m-rounded-2xl m-bg-elevated m-text-warning">
        <ShieldAlert className="m-size-8" aria-hidden="true" />
      </span>
      <h1 className="m-mt-5 m-text-2xl m-font-bold m-text-foreground">
        {zeroCapability ? translate("Sizga vazifa biriktirilmagan") : translate("Bu bo‘lim uchun ruxsat yo‘q")}
      </h1>
      <p className="m-mt-3 m-text-sm m-leading-6 m-text-muted">
        {zeroCapability
          ? translate("Ustaxona egasi sizga usta, sotuvchi yoki omborchi huquqini biriktirgach biznes bo‘limlari ochiladi.")
          : translate("Hisobingizda ushbu bo‘lim uchun kerakli huquq yo‘q.")}
      </p>
      <div className="m-mt-7 m-grid m-grid-cols-2 m-gap-3">
        <Link className="m-secondary-button m-min-w-0 m-flex-col m-gap-1" to="/mechanic/support">
          <Headphones className="m-size-5" aria-hidden="true" />
          {translate("Yordam")}</Link>
        <Link className="m-secondary-button m-min-w-0 m-flex-col m-gap-1" to="/mechanic/profile">
          <CircleUserRound className="m-size-5" aria-hidden="true" />
          {translate("Profil")}</Link>
      </div>
    </section>
  );
}
